/**
 * Den Earnings-Termin holen — die Datenbankseite zu `earnings-abstand.ts`.
 *
 * Warum eine eigene Abfrage statt `useEarnings`: Der Hook holt zusätzlich
 * Historie und Schätzungen und fällt auf einen Live-Aufruf zurück. Für die
 * Kauf-Sperre wird nur EIN Datum gebraucht, und zwar aus dem Bestand — ein
 * fehlgeschlagener Fremdaufruf darf den Dialog nicht aufhalten.
 *
 * Kein Ergebnis heißt `null` und damit „nicht prüfbar", nicht „kein Termin".
 * Den Unterschied macht die Anzeige sichtbar.
 */

import { supabase } from '@/lib/supabase';
import { kalendertageBis } from './earnings-abstand';

export async function fetchTageBisEarnings(
  symbol: string,
  heute = new Date().toISOString().slice(0, 10)
): Promise<number | null> {
  try {
    const { data, error } = await supabase
      .from('v5_earnings_cache')
      .select('next_earnings_date')
      .eq('symbol', symbol.toUpperCase())
      .maybeSingle();

    if (error || !data?.next_earnings_date) return null;
    return kalendertageBis(String(data.next_earnings_date), heute);
  } catch {
    // Eine kaputte Abfrage darf die Übernahme nicht blockieren — sie führt
    // zu „Termin unbekannt", und das steht dann auch da.
    return null;
  }
}
